export const priorityOptions = [
  { value: -1, label: 'Low Precedence' },
  { value: 1, label: 'Normal' },
  { value: 2, label: 'Elevated' },
  { value: 3, label: 'Urgent' },
]

export const medicationUnits = [
  { value: 'C100052', label: 'Needle Free Injection' },
  { value: 'C101680', label: 'French' },
  { value: 'C111984', label: 'Pump' },
  { value: 'C120216', label: 'Pen Needle' },
  { value: 'C120263', label: 'Lancet' },
  { value: 'C16830', label: 'Device' },
  { value: 'C28251', label: 'Millimeter' },
  { value: 'C28252', label: 'Kilogram' },
  { value: 'C28253', label: 'Milligram' },
  { value: 'C28254', label: 'Milliliter' },
  { value: 'C38046', label: 'Unspecified' },
  { value: 'C48155', label: 'Gram' },
  { value: 'C48473', label: 'Ampule' },
  { value: 'C48474', label: 'Bag' },
  { value: 'C48475', label: 'Bar' },
  { value: 'C48476', label: 'Bolus' },
  { value: 'C48477', label: 'Bottle' },
  { value: 'C48478', label: 'Box' },
  { value: 'C48479', label: 'Can' },
  { value: 'C48480', label: 'Capsule' },
  { value: 'C48481', label: 'Cartridge' },
  { value: 'C48484', label: 'Container' },
  { value: 'C48489', label: 'Cylinder' },
  { value: 'C48490', label: 'Disk' },
  { value: 'C48491', label: 'Metric Drop' },
  { value: 'C48494', label: 'Fluid Ounce' },
  { value: 'C48499', label: 'Implant' },
  { value: 'C48501', label: 'Inhalation' },
  { value: 'C48504', label: 'Kit' },
  { value: 'C48505', label: 'Liter' },
  { value: 'C48506', label: 'Lozenge' },
  { value: 'C48512', label: 'Milliequivalent' },
  { value: 'C48519', label: 'Ounce' },
  { value: 'C48520', label: 'Package' },
  { value: 'C48521', label: 'Packet' },
  { value: 'C48524', label: 'Patch' },
  { value: 'C48529', label: 'Pint' },
  { value: 'C48530', label: 'Pouch' },
  { value: 'C48531', label: 'Pound' },
  { value: 'C48534', label: 'Quart' },
  { value: 'C48536', label: 'Scoopful' },
  { value: 'C48537', label: 'Spray' },
  { value: 'C48538', label: 'Strip' },
  { value: 'C48539', label: 'Suppository' },
  { value: 'C48540', label: 'Syringe' },
  { value: 'C48541', label: 'Tablespoon' },
  { value: 'C48542', label: 'Tablet' },
  { value: 'C48543', label: 'Tampon' },
  { value: 'C48544', label: 'Teaspoon' },
  { value: 'C48548', label: 'Troche' },
  { value: 'C48549', label: 'Tube' },
  { value: 'C48551', label: 'Vial' },
  { value: 'C48552', label: 'Wafer' },
  { value: 'C48580', label: 'Gallon' },
  { value: 'C53495', label: 'Bead' },
  { value: 'C53498', label: 'Block' },
  { value: 'C53499', label: 'Film' },
  { value: 'C53502', label: 'Sponge' },
  { value: 'C53503', label: 'Stick' },
  { value: 'C53504', label: 'Swab' },
  { value: 'C54564', label: 'Blister' },
  { value: 'C54702', label: 'Carton' },
  { value: 'C54704', label: 'Tray' },
  { value: 'C62275', label: 'Inhaler' },
  { value: 'C62276', label: 'Insert' },
  { value: 'C62412', label: 'Applicator' },
  { value: 'C62413', label: 'Canister' },
  { value: 'C62414', label: 'Case' },
  { value: 'C62417', label: 'Dose Pack' },
  { value: 'C62418', label: 'Inhaler Refill' },
  { value: 'C62421', label: 'Tabminder' },
  { value: 'C62609', label: 'Ring' },
  { value: 'C64696', label: 'Caplet' },
  { value: 'C64933', label: 'Each' },
  { value: 'C65032', label: 'Pad' },
  { value: 'C65060', label: 'Puff' },
  { value: 'C67283', label: 'Intravenous Bag' },
  { value: 'C69086', label: 'Ocular System' },
  { value: 'C69093', label: 'Cassette' },
  { value: 'C69124', label: 'Gum' },
  { value: 'C71204', label: 'Nebule' },
  { value: 'C71324', label: 'Sachet' },
  { value: 'C78783', label: 'Applicatorful' },
  { value: 'C82484', label: 'Paper' },
  { value: 'C96265', label: 'Dual Pack' },
  { value: 'C97717', label: 'Pre-filled Pen Syringe' },
]

export const compoundReasons = [
  { reason: 'Drug Shortage or Backorder' },
  { reason: 'Commercially Available Product Discontinued' },
  { reason: 'Modified Release' },
  { reason: 'Inactive Ingredient Sensitivity/Allergy' },
  { reason: 'Inactive Ingredient Toxic to Species' },
  {
    reason: 'Concentration Adjustment Necessary',
    subReasons: ['Tablet/Capsule Burden', 'Unable to fractionate commercial product'],
  },
  { reason: 'Alternate Administration Route' },
  { reason: 'Patient Noncompliance', subReasons: ['Flavor Not Tolerated'] },
  { reason: 'Alcohol Free' },
  { reason: 'No Rationale Required', subReasons: ['No FDA-approved product available'] },
]

export const defaultMedicationValues = {
  medication: '',
  dose: '',
  refills: '',
  quantity: '',
  unit: '',
  sig: '',
  reason: '',
  additionalContext: '',
  daysSupply: '',
  flavor: '',
  notes: '',
  program: '',
  program_id: '',
  doNotFill: false,
  doNotRefill: false,
  refillNeeded: false,
  patientContactRequested: false,
}
